module.exports = __webpack_public_path__ + "d4486f01.svg";